export default __webpack_public_path__ + "static/media/logo_red.83bcc17e.png";